module.exports = __webpack_public_path__ + "static/media/contact-entity.1305f768.svg";